import React from 'react'
import ReactHtmlParser from 'react-html-parser'

export default function Question({ question }) {
	return <div className='text-Question'>{ReactHtmlParser(question)}</div>
}
